export const CONNECTOR_META = {
    salesforce: {
      requiresInstanceUrl: true,
      requiresApiVersion: false,
    },
    oracle: {
      requiresInstanceUrl: true,
      requiresApiVersion: false,
    },
    sql: {
      requiresInstanceUrl: false,
      requiresApiVersion: true,
    },
    hubspot: {
      requiresInstanceUrl: true,
      requiresApiVersion: false,
    },
    // Add more as needed
  };
  
  export const defaultConnectorMeta = {
    requiresInstanceUrl: false,
    requiresApiVersion: true,
  };
  
